import { Link } from 'react-router-dom';
import './NotFound.css';

export default function NotFound() {
  return (
    <div className="not-found-wrapper">
      <h1>Oops, page not found</h1>
      <p>The page you requested could not be found</p>

      <Link to="/" className="back-home-btn">
        <span className="arrow-left">←</span>
        Back to homepage
      </Link>
    </div>
  );
}
